(function () {
  "use strict";

  class GenCategorySlider extends HTMLElement {
    connectedCallback() {
      if (this.swiper) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.init();
        },
        { rootMargin: "200px" }
      );
      this.observer.observe(this);
    }

    async init() {
      try {
        await window.GenLoader.load("swiper");
      } catch (e) {
        console.error("[gen-category-slider] không tải được Swiper", e);
        return;
      }

      const mobileSlides = parseFloat(this.getAttribute("mobile-slides")) || 1.4;

      this.swiper = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: mobileSlides,
        spaceBetween: 20,
        breakpoints: {
          550:  { 
            slidesPerView: 3, 
            spaceBetween: 30 
          },
          768:  { 
            slidesPerView: 4, 
            spaceBetween: 30 
          },
          1440: { 
            slidesPerView: 4, 
            spaceBetween: 60 
          },
          1770: { 
            slidesPerView: 4, 
            spaceBetween: 90 
          },
        },
        navigation: {
          nextEl: this.querySelector(".gen-swiper-button--next"),
          prevEl: this.querySelector(".gen-swiper-button--prev"),
        },
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!customElements.get("gen-category-slider")) {
    customElements.define("gen-category-slider", GenCategorySlider);
  }
})();